import React, { ReactNode, useRef, useState } from 'react';
import * as styles from './QuestionAndAnswer.module.scss';
import classNames from 'classnames';
import { QuestionAndAnswerProps } from './QuestionAndAnswerProps';

export const QuestionAndAnswer: React.FC<QuestionAndAnswerProps> = ({
	question,
	answer,
	children,
}) => {
	const questionRef = useRef<HTMLDivElement>(null);
	const [isExpanded, setIsExpanded] = useState(false);

	const onClick = () => {
		setIsExpanded(!isExpanded);
	};

	return (
		<div
			className={classNames(
				styles.questionBox,
				isExpanded && styles.expand,
				'font-size-22'
			)}
		>
			<div
				ref={questionRef}
				onClick={onClick}
				className={classNames(
					styles.question,
					'd-flex justify-content-between py-4'
				)}
			>
				<div className={classNames(styles.questionContent, 'font-500')}>
					{question}
				</div>
				<div className={styles.arrow}></div>
			</div>
			{answer ? (
				<div
					className={classNames(styles.answer, 'font-300')}
					dangerouslySetInnerHTML={{ __html: answer }}
				/>
			) : (
				<div className={classNames(styles.answer, 'font-300')}>{children}</div>
			)}
			<div className={styles.underline}></div>
		</div>
	);
};
